function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.4519 0.581299H19.9722C8.94599 0.594208 0.0109399 9.81939 0 21.2036V140.915C0.0109399 152.299 8.94599 161.525 19.9722 161.536H82.4519C93.4781 161.525 102.413 152.299 102.426 140.915V21.2036C102.413 9.81939 93.4781 0.594208 82.4519 0.581299ZM51.2128 143.912C46.4976 143.912 42.6763 139.966 42.6763 135.098C42.6763 130.231 46.4976 126.286 51.2128 126.286C55.9265 126.286 59.7478 130.231 59.7478 135.098C59.7478 139.966 55.9265 143.912 51.2128 143.912ZM64.016 27.0192H38.4096C36.0528 27.0192 34.1414 25.0457 34.1414 22.6123C34.1414 20.179 36.0528 18.2071 38.4096 18.2071H64.016C66.3729 18.2071 68.2827 20.179 68.2827 22.6123C68.2827 25.0457 66.3729 27.0192 64.016 27.0192Z",
  fill: "currentColor"
});

var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 103,
    height: 162,
    viewBox: "0 0 103 162",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-icon.01a6d70e.svg";
export { ForwardRef as ReactComponent };